import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareSetare } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareSetare() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareSetare,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.setari() });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
